import React from 'react';
import { useClientMessages } from './Client/ClientMessageContext';
import { useGeneralMessages } from './General/GeneralMessageContext';

interface MessageBannerProps {
  className?: string;
}

export const MessageBanner: React.FC<MessageBannerProps> = ({ className = '' }) => {
  const { visibleMessages: clientMessages, dismissMessage: dismissClientMessage } = useClientMessages();
  const { visibleMessages: generalMessages, dismissMessage: dismissGeneralMessage } = useGeneralMessages();

  // Filter for banner type messages only
  const clientBannerMessages = clientMessages.filter(message => 
    message?.data?.displayType === 'BANNER'
  );
  
  const generalBannerMessages = generalMessages.filter(message => 
    message?.data?.displayType === 'BANNER'
  );

  // Combine both types of messages
  const allBannerMessages = [...clientBannerMessages, ...generalBannerMessages];

  if (allBannerMessages.length === 0) {
    return null;
  }

  const handleButtonClick = (message: any) => {
    if (!message?.data?.button) return;
    
    const { action, link } = message.data.button;
    
    switch (action) {
      case 'INTERNAL_LINK':
        if (link) {
          window.location.href = link;
        }
        break;
      case 'EXTERNAL_LINK':
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer');
        }
        break;
      case 'CLOSE':
        // Determine which dismiss function to use based on message source
        if (clientBannerMessages.some(m => m.id === message.id)) {
          dismissClientMessage(message.id);
        } else {
          dismissGeneralMessage(message.id);
        }
        break;
      case 'NONE':
      default:
        // Do nothing
        break;
    }
  };

  const handleDismiss = (messageId: string) => {
    // Determine which dismiss function to use based on message source
    if (clientBannerMessages.some(m => m.id === messageId)) {
      dismissClientMessage(messageId);
    } else {
      dismissGeneralMessage(messageId);
    }
  };

  return (
    <div className={`message-banner-container ${className}`}>
      {allBannerMessages.map((message) => (
        <div key={message.id} className="message-banner">
          <div className="message-banner-content">
            <div className="message-banner-text">
              <h3 className="message-banner-title">{message.data?.title || 'Message'}</h3>
              <p className="message-banner-message">{message.data?.message || ''}</p>
            </div>
            
            <div className="message-banner-actions">
              {message.data?.button?.enabled && message.data?.button?.text && (
                <button
                  className="message-banner-button"
                  onClick={() => handleButtonClick(message)}
                >
                  {message.data.button.text}
                </button>
              )}
              
              {message.data?.dismissible && (
                <button
                  className="message-banner-dismiss"
                  onClick={() => handleDismiss(message.id)}
                  aria-label="Dismiss message"
                >
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}; 